export const RollingYear = ({ year, className = "", testid }) => {
  const digits = String(Math.round(year)).padStart(4, "0").split("");
  return (
    <div className={`flex font-display tabular-nums ${className}`} style={{ lineHeight: 1.15 }} data-testid={testid} aria-label={`Year ${Math.round(year)}`}>
      {digits.map((d, i) => (
        <span key={i} className="relative inline-block overflow-hidden" style={{ height: "1.15em", width: "0.62em" }}>
          <span className="absolute left-0 top-0 w-full flex flex-col transition-transform duration-300 ease-out" style={{ transform: `translateY(-${Number(d) * 1.15}em)` }}>
            {Array.from({ length: 10 }, (_, n) => <span key={n} style={{ height: "1.15em" }} className="block text-center">{n}</span>)}
          </span>
        </span>
      ))}
    </div>
  );
};
